import { render, staticRenderFns } from "./organizations.vue?vue&type=template&id=629d05aa&"
import script from "./organizations.vue?vue&type=script&lang=ts&"
export * from "./organizations.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "organizations.vue"
export default component.exports